var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackSide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 616.954,
    height: 564.53,
    viewBox: "0 0 616.954 564.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41467",
    "data-name": "Group 41467",
    transform: "translate(-117.198 -600.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Objects",
    transform: "translate(89.432 556.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(28.766 44.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M358.5,300.9c4.838,8.058,9.124,17.3,17,22.532,8.432,5.607,19.516,8.571,28.5,13.47,18.357,10.011,35.778,23.111,45.672,41.995,9.976,19.045,11.048,41.759,7.174,62.906s-12.354,41.132-20.774,60.915",
    transform: "translate(99.775 55.658)",
    fill: "none",
    stroke: "#e3ecf7",
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M339.045,236.534c3.572,31.164,10.76,62.338,27.046,89.459",
    transform: "translate(92.189 30.567)",
    fill: "none",
    stroke: "#e3ecf7",
    strokeWidth: 1.06,
    strokeDasharray: 8.476
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M133.76,238.986c17.583-35.521,52.538-60.285,89.07-74.321,41.611-15.989,90.3-14.843,129.414,6.535,35.969,19.66,62.139,56.691,66.827,97.6",
    transform: "translate(12.163 -1.696)",
    fill: "none",
    stroke: "#e3ecf7",
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M113.94,271.807c11.433-17.662,18.214-37.866,27.546-56.722",
    transform: "translate(4.437 22.205)",
    fill: "none",
    stroke: "#e3ecf7",
    strokeWidth: 1.06,
    strokeDasharray: 8.476
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M120.731,524.6a138.694,138.694,0,0,1-67.639-90.685c-9.5-43.629,1.812-85.941,31.828-118.612,18.141-19.744,39.446-36.9,54.017-59.408",
    transform: "translate(-20.561 38.115)",
    fill: "none",
    stroke: "#e3ecf7",
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(218.841 180.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M379.882,243.5l-93.727,93.742-30.57,30.57-20.7-20.7-3.549-3.549-45.1-45.1,124.3-124.313Z",
    transform: "translate(-186.224 -174.143)",
    fill: "#7ca8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M262.642,298.594l-20.7,20.7-20.7-20.7Z",
    transform: "translate(-172.578 -125.629)",
    fill: "#6194cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M310.528,174.148l-124.3,124.3,96.828-27.475Z",
    transform: "translate(-186.225 -174.141)",
    fill: "#97bce8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Hand-money",
    transform: "translate(321.192 75.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M395.73,180.254c-1.242-.395-2.45-.862-3.637-1.366a40.936,40.936,0,0,1-23.085-25.512,18.518,18.518,0,0,1-.675-7.083c1.083-12.572-.746-26.112-15.58-39.835a6.814,6.814,0,0,0-9.148-.22,6.623,6.623,0,0,0-.021,9.779c11.894,10.912,12.668,20.736,11.244,32.116-2.556-17.113-9.534-38.311-36.106-48.94a7.839,7.839,0,0,0-10.663,6.158,7.938,7.938,0,0,0,5.035,8.449c19.708,7.968,24.526,23.463,26.468,38.051-9.958-22.671-25.92-33.78-50.952-36.242a8.422,8.422,0,0,0-9.238,7.872,8.689,8.689,0,0,0,7.976,8.941c17.056,1.748,29.77,7.776,38.213,29.7-24.444-8.3-41.158-11.541-61.494.852A8.672,8.672,0,0,0,261.217,175a8.427,8.427,0,0,0,11.419,2.493c11.137-6.845,25.431-7.63,49.992,1.494a36.558,36.558,0,0,1,12.1,12.39c2.913,7.825,6.73,21.377-1.64,30.4-8.432,9.094-27.863,11.829-36.373,11.7-1.294-.174-2.6-.391-3.921-.667A8.43,8.43,0,1,0,289,249.238c9.352,2.01,14.663,1.087,24.564.35,2.036-.152,5.046-.493,7.037-.823a147.342,147.342,0,0,0,17.64-4.081L378.53,233.74a66.346,66.346,0,0,1,17.392-2.32h0Z",
    transform: "translate(-259.868 -98.632)",
    fill: "#feaa90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 30.282,
    height: 62.475,
    transform: "translate(134.424 78.995)",
    fill: "#f2f7fc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M365.028,192.12a5.873,5.873,0,1,0,5.873-5.873A5.873,5.873,0,0,0,365.028,192.12Z",
    transform: "translate(-218.874 -64.478)",
    fill: "#1bd8da"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M513.5,482.412H315.711l1.268-2.517,50.169-99.163c14.638-12.457,33.795-20.321,52.954-18.789a51.219,51.219,0,0,1,6.67.958c16.7,3.43,31.984,14.578,38.169,30.393a31.38,31.38,0,0,1,2.268,15.3,19.57,19.57,0,0,1-7.422,13.281c4.446-3.077,11.338-1.237,15.462,2.268a12.715,12.715,0,0,1,3.122,14.74c4.137-3.019,10.44.619,13.562,4.682,3.108,4.079,4.124,9.306,5.7,14.18C500.693,467.142,513.5,482.412,513.5,482.412Z",
    transform: "translate(83.093 79.38)",
    fill: "#e3ecf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M426.44,362.9l-4.388,119.511H316.559l.089-2.517,50.169-99.163c14.638-12.457,33.795-20.321,52.954-18.789A51.219,51.219,0,0,1,426.44,362.9Z",
    transform: "translate(83.423 79.38)",
    fill: "#cedef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M205.361,487.373l-67.133.074-91.063.089c-9.866-20.72,14.387-37.213,35.753-25.873-13.622-15.05.855-34.59,20.057-28.862-8.761-8.422,5.051-19.187,11.117-7.746-1.148-9.851-5.566-40.583,16.757-59.123,10.485-8.717,26.875-14.739,52.291-14.636Z",
    transform: "translate(-22.477 75.303)",
    fill: "#e3ecf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M181.253,487.373l-67.133.074-7.379-121.515c10.485-8.717,26.875-14.739,52.291-14.636Z",
    transform: "translate(1.631 75.303)",
    fill: "#cedef2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(105.228 356.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M500.3,310.429l-.147,2.533-2.518,42.512-8.762,148.153H120.793L111,338.393l-1.355-23.1-.295-4.859Z",
    transform: "translate(-102.833 -297.084)",
    fill: "#1bd8da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M500.068,312.251l-2.518,42.512L110.918,337.682l-1.355-23.1Z",
    transform: "translate(-102.75 -296.373)",
    fill: "#13b8b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M507.05,338.512H106.264l-1.6-37.685H508.653Z",
    transform: "translate(-104.661 -300.827)",
    fill: "#1bd8da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Feedback",
    transform: "translate(197.824 153.432)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -41,
    y: 0
  }, "Feedback")), /*#__PURE__*/React.createElement("text", {
    id: "Box",
    transform: "translate(201.659 177.696)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16,
    y: 0
  }, "Box")), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M134.356,343.232a2.589,2.589,0,1,1-2.588-2.589A2.589,2.589,0,0,1,134.356,343.232Z",
    transform: "translate(-94.851 -285.306)",
    fill: "#13b8b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M178.278,363.466a2.219,2.219,0,1,1-2.218-2.22A2.218,2.218,0,0,1,178.278,363.466Z",
    transform: "translate(-77.441 -277.274)",
    fill: "#13b8b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M146.163,396.928a3.082,3.082,0,1,1-3.083-3.081A3.083,3.083,0,0,1,146.163,396.928Z",
    transform: "translate(-90.633 -264.565)",
    fill: "#13b8b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M181.406,433.458a2.343,2.343,0,1,1-2.342-2.342A2.342,2.342,0,0,1,181.406,433.458Z",
    transform: "translate(-76.318 -250.037)",
    fill: "#13b8b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M371.135,351.3a3.323,3.323,0,1,1-3.323-3.323A3.323,3.323,0,0,1,371.135,351.3Z",
    transform: "translate(-3.121 -282.445)",
    fill: "#13b8b9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2.736,
    cy: 2.736,
    r: 2.736,
    transform: "translate(276.539 100.328)",
    fill: "#13b8b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M367.76,432.03a3.323,3.323,0,1,1-3.323-3.323A3.323,3.323,0,0,1,367.76,432.03Z",
    transform: "translate(-4.436 -250.976)",
    fill: "#13b8b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M314.318,432.03a3.323,3.323,0,1,1-3.323-3.323A3.323,3.323,0,0,1,314.318,432.03Z",
    transform: "translate(-25.27 -250.976)",
    fill: "#13b8b9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2.979,
    cy: 2.979,
    r: 2.979,
    transform: "translate(327.63 119.812)",
    fill: "#13b8b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M359.748,312.131a2.979,2.979,0,1,1-2.98-2.978A2.98,2.98,0,0,1,359.748,312.131Z",
    transform: "translate(-7.292 -297.581)",
    fill: "#13b8b9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.152,
    cy: 2.152,
    r: 2.152,
    transform: "translate(47.429 10.082)",
    fill: "#13b8b9"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 614.954,
    transform: "translate(0 563)",
    fill: "none",
    stroke: "#13b8b9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "_0",
    "data-name": 0,
    transform: "translate(162.022 85.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M161.654,112.772h-2.306a2.312,2.312,0,0,1-2.311-2.313v-2.3a2.4,2.4,0,0,0-1.857-2.381,2.331,2.331,0,0,0-2.794,2.278v2.407a2.311,2.311,0,0,1-2.311,2.313h-2.306a2.4,2.4,0,0,0-2.379,1.855,2.331,2.331,0,0,0,2.278,2.794h2.407a2.311,2.311,0,0,1,2.311,2.313v2.3a2.4,2.4,0,0,0,1.857,2.381,2.331,2.331,0,0,0,2.794-2.278v-2.407a2.312,2.312,0,0,1,2.311-2.313h2.407a2.332,2.332,0,0,0,2.279-2.794A2.4,2.4,0,0,0,161.654,112.772Z",
    transform: "translate(-145.343 -105.727)",
    fill: "#cedef2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_0-2",
    "data-name": 0,
    transform: "translate(267.105 13.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M220.952,61.433h0a7.6,7.6,0,0,0,7.6,7.6h27.42a2.87,2.87,0,0,1,2.87,2.87h0a2.87,2.87,0,0,1-2.87,2.87h-4.04a4.958,4.958,0,0,0-4.958,4.958v.263a4.958,4.958,0,0,0,4.958,4.958h53.39a4.958,4.958,0,0,0,4.958-4.958h0a4.957,4.957,0,0,0-4.958-4.958H268.913a2.871,2.871,0,0,1-2.87-2.87V71.9a2.87,2.87,0,0,1,2.87-2.87h15.46a7.6,7.6,0,0,0,7.6-7.6h0a7.6,7.6,0,0,0-7.6-7.6H228.553A7.6,7.6,0,0,0,220.952,61.433Z",
    transform: "translate(-220.952 -53.831)",
    fill: "#e3ecf7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0-3",
    "data-name": 0,
    transform: "translate(246.525 198.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M213.942,219.842V257.7a3.91,3.91,0,0,1-3.9,3.9h0a3.911,3.911,0,0,1-3.9-3.9V219.842a3.912,3.912,0,0,1,3.9-3.9h0A3.911,3.911,0,0,1,213.942,219.842Z",
    transform: "translate(-206.144 -175.74)",
    fill: "#b5cfed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M213.942,206.884v4.4a3.91,3.91,0,0,1-3.9,3.9h0a3.911,3.911,0,0,1-3.9-3.9v-4.4a3.911,3.911,0,0,1,3.9-3.9h0A3.91,3.91,0,0,1,213.942,206.884Z",
    transform: "translate(-206.144 -180.79)",
    fill: "#b5cfed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M213.942,190.916v.784a3.911,3.911,0,0,1-3.9,3.9h0a3.912,3.912,0,0,1-3.9-3.9v-.784a3.912,3.912,0,0,1,3.9-3.9h0A3.911,3.911,0,0,1,213.942,190.916Z",
    transform: "translate(-206.144 -187.016)",
    fill: "#b5cfed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_0-4",
    "data-name": 0,
    transform: "translate(390.879 277.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 37.399,
    height: 6.388,
    rx: 2.298,
    transform: "translate(0 70.331) rotate(-90)",
    fill: "#b5cfed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 9.989,
    height: 6.388,
    rx: 2.298,
    transform: "translate(0 28.17) rotate(-90)",
    fill: "#b5cfed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 7.031,
    height: 6.388,
    rx: 2.298,
    transform: "translate(0 7.031) rotate(-90)",
    fill: "#b5cfed"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M129.376,189.93a3.192,3.192,0,1,1-3.191-3.191A3.191,3.191,0,0,1,129.376,189.93Z",
    transform: "translate(7.966 11.155)",
    fill: "#e3ecf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M69.786,250.329a6.383,6.383,0,1,1-6.383-6.385A6.384,6.384,0,0,1,69.786,250.329Z",
    transform: "translate(-17.752 33.455)",
    fill: "none",
    stroke: "#e3ecf7",
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 4.353,
    cy: 4.353,
    r: 4.353,
    transform: "translate(61.345 133.579)",
    fill: "#cedef2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 4.353,
    cy: 4.353,
    r: 4.353,
    transform: "translate(161.717)",
    fill: "none",
    stroke: "#e3ecf7",
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M392.093,73.467A4.062,4.062,0,1,1,388.03,69.4,4.063,4.063,0,0,1,392.093,73.467Z",
    transform: "translate(109.701 -34.585)",
    fill: "none",
    stroke: "#e3ecf7",
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.902,
    cy: 2.902,
    r: 2.902,
    transform: "matrix(0.385, -0.923, 0.923, 0.385, 248.455, 122.852)",
    fill: "none",
    stroke: "#e3ecf7",
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M149.582,258.7a3.482,3.482,0,1,1-3.482-3.482A3.481,3.481,0,0,1,149.582,258.7Z",
    transform: "translate(15.617 37.85)",
    fill: "none",
    stroke: "#e3ecf7",
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M414.966,259.861a4.643,4.643,0,1,1-4.643-4.642A4.643,4.643,0,0,1,414.966,259.861Z",
    transform: "translate(118.165 37.85)",
    fill: "none",
    stroke: "#e3ecf7",
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M431.017,315.07a3.482,3.482,0,1,1-3.482-3.482A3.483,3.483,0,0,1,431.017,315.07Z",
    transform: "translate(125.327 59.825)",
    fill: "#e3ecf7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(485.898 154.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M482.964,185.147H465.247a5.439,5.439,0,1,1,0-10.878h3.513a9.4,9.4,0,1,0,0-18.8H378.377v62.475h85.187a5.321,5.321,0,1,0,0-10.642H448.189a3.308,3.308,0,0,1,0-6.617h34.775a7.771,7.771,0,1,0,0-15.541Z",
    transform: "translate(-378.377 -155.471)",
    fill: "#1bd8da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M469.623,164.257a7.247,7.247,0,1,1-7.247-7.247A7.247,7.247,0,0,1,469.623,164.257Z",
    transform: "translate(-348.457 -154.871)",
    fill: "#1bd8da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M459.43,197.923a4.8,4.8,0,1,1-4.8-4.795A4.8,4.8,0,0,1,459.43,197.923Z",
    transform: "translate(-350.52 -140.791)",
    fill: "#1bd8da"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41464",
    "data-name": "Group 41464",
    transform: "translate(-102.026 41.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-smile",
    "data-name": "Icon awesome-smile",
    d: "M25.638.563A25.638,25.638,0,1,0,51.276,26.2,25.634,25.634,0,0,0,25.638.563Zm8.27,17.368A3.308,3.308,0,1,1,30.6,21.238,3.3,3.3,0,0,1,33.908,17.93Zm-16.541,0a3.308,3.308,0,1,1-3.308,3.308A3.3,3.3,0,0,1,17.368,17.93Zm20.138,17.6a15.443,15.443,0,0,1-23.736,0,1.655,1.655,0,0,1,2.543-2.119,12.147,12.147,0,0,0,18.65,0A1.655,1.655,0,0,1,37.506,35.525Z",
    transform: "translate(502.063 990.438)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSide);
export default __webpack_public_path__ + "static/media/feedback-side.1b5f1304ae9c5571c5c4d5ed839210af.svg";
export { ForwardRef as ReactComponent };